import { __extends } from "tslib";
import * as React from 'react';
var CustomizedXAxisTick = /** @class */ (function (_super) {
    __extends(CustomizedXAxisTick, _super);
    function CustomizedXAxisTick() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.value = _this.props.payload && _this.props.payload.value;
        return _this;
    }
    CustomizedXAxisTick.prototype.render = function () {
        return (React.createElement("g", { className: 'xaxis-container', transform: "translate(" + this.props.x + "," + this.props.y + ")" },
            React.createElement("text", { dy: 5, dx: -5, textAnchor: 'end', fontSize: '12', fill: '#577083', transform: 'rotate(-45)', opacity: '0.77' }, this.value && this.value.length > 10 ? this.value.slice(0, 9) + '...' : this.value)));
    };
    return CustomizedXAxisTick;
}(React.PureComponent));
export { CustomizedXAxisTick };
//# sourceMappingURL=customized-x-axis-tick.js.map